import Search from "@arcgis/core/widgets/Search"
import globalLayers from "../../../Utils/CustomerMaps/Maps/GlobaLMap"

export const disableSearchWidget = (isDisable: boolean) => {
    if(Object.keys(globalLayers.searchWidgetInput).length){
        (globalLayers.searchWidgetInput as __esri.Search).set('disable', isDisable);
        (globalLayers.searchWidgetInput as Search).disabled = isDisable;
    }
}